import { getAPI } from '@sydle/ui-api';
import type { UserAPI, UserData } from '@sydle/ui-api';

interface User extends UserData {
  photo: {
    _id: string;
  };
  _class: {
    _id: string;
  };
  token: string;
}

export function getUser(): User | undefined {
  let user: User = getAPI<UserAPI>('userAPI')?.getUser() as User;
  if (user?.accessToken?.payload) {
    user = { ...user, ...user.accessToken.payload, token: user.accessToken.token };
  }
  return user;
}

export function logout(): void {
  getAPI<UserAPI>('userAPI')?.logout();
  localStorage.removeItem('siteUser');
  window.location.reload();
}
